import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const AlignLeftIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M0.333292 14.6666L10.3333 14.6666C10.5174 14.6666 10.6666 14.5174 10.6666 14.3333V13.6666C10.6666 13.4825 10.5174 13.3333 10.3333 13.3333L0.333292 13.3333C0.149198 13.3333 -4.1008e-05 13.4825 -4.1008e-05 13.6666V14.3333C-4.1008e-05 14.5174 0.149198 14.6666 0.333292 14.6666Z"
        fill={color}
      />
      <path
        d="M0.333292 6.66663L10.3333 6.66663C10.5174 6.66663 10.6666 6.51739 10.6666 6.33329V5.66663C10.6666 5.48253 10.5174 5.33329 10.3333 5.33329L0.333292 5.33329C0.149198 5.33329 -4.1008e-05 5.48253 -4.1008e-05 5.66663V6.33329C-4.1008e-05 6.51739 0.149198 6.66663 0.333292 6.66663Z"
        fill={color}
      />
      <path
        d="M0.333333 2.66663L15.6667 2.66663C15.8508 2.66663 16 2.51739 16 2.33329V1.66663C16 1.48253 15.8508 1.33329 15.6667 1.33329L0.333333 1.33329C0.149238 1.33329 0 1.48253 0 1.66663V2.33329C0 2.51739 0.149238 2.66663 0.333333 2.66663Z"
        fill={color}
      />
      <path
        d="M0.333333 10.6666L15.6667 10.6666C15.8508 10.6666 16 10.5174 16 10.3333V9.66663C16 9.48253 15.8508 9.33329 15.6667 9.33329L0.333333 9.33329C0.149238 9.33329 0 9.48253 0 9.66663V10.3333C0 10.5174 0.149238 10.6666 0.333333 10.6666Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

AlignLeftIcon.displayName = 'AlignLeftIcon';
